<style  scoped>
.no-gutters {
    margin-right: -1px !important;
}
.reportrange-text {
  height: 40px !important;
  padding-top: 9px !important;
}
</style>
<template>
    <div>
      <!-- Filter -->
      <CRow>
        <div class="col-sm-12 col-xl-6">
          <div class="form-group">
            <label for="" class="font-weight-bold">Pilih Periode</label>
            <multiselect
              class="mulit-select"
              label="label"
              placeholder="Pilih Periode"
              :show-labels="false"
              required
              :loading="loadingMultiSelect.isLoadingPeriode"
              v-model="periode"
              @select="changePeriode"
              :options="dataTahun"
            ></multiselect>
          </div>
        </div>
        <div class="col-sm-12 col-xl-6">
          <div class="form-group">
            <label for="" class="font-weight-bold">Pilih Sertifikasi</label>
            <multiselect
              class="mulit-select"
              label="namaSertifikasi"
              placeholder="Pilih Sertifikasi"
              :show-labels="false"
              required
              v-model="sertifikasi"
              :loading="loadingMultiSelect.isLoadingSertifikasi"
              @select="changeSertifikasi"
              :options="dataSertifikasi"
            ></multiselect>
          </div>
        </div>
        <div class="col-sm-12 col-xl-12">
          <div style="float:right">
            <button class="btn btn-warning mr-1 text-white" @click="ekspor">Export Data</button>
            <button class="btn btn-info mr-1" @click="resetFilter">Reset Filter</button>
            <button class="btn btn-success mr-1" @click="filterData">Terapkan</button>
          </div>
        </div>     
      </CRow>
      <br>
      <CRow>
        
        <div class="col-sm-12 col-xl-6">
          <div class="form-group">
            
            <CSelect
              class="float-left"
              label="Data Perhalaman"
              placeholder="Data Per Halaman"
              @change="changePageSizeDataPesertaSertifikasi"
              :options="[10, 25, 100, 'Semua Data']"
            />
          </div>
        </div>
        <div class="col-sm-12 col-xl-6 ml-auto">
          <div class="form-group">
            <CInput
              label="Pencarian"
              class="float-right"
              placeholder="Cari Data .."
              @keyup="searchMethods($event)"
            />
          </div>
        </div>
      </CRow>
      <!-- filter -->
    </div>
</template>
<script>
import MasterSertifikasiService from "../../../services/sertifikasi/master-sertifikasi.service.new";
import PeriodeService from '../../../services/datamaster/periode.service'

export default {
  name: 'FilterSertifikasi',      
  props: [
    'searchData'
  ],
  data() {
    return {
      loadingMultiSelect : {
        isLoadingPeriode : true,
        isLoadingSertifikasi : true,
      },
      formFilter : {
        periode : '',
        id_sertifikasi : '',
        status_pembayaran : '',        
      },      
      periode :'',
      sertifikasi : '',      
      dataSertifikasi: [],
      dataTahun : [],
      searchField : ''
    }
},         
    
  mounted() {
    this.getPeriode();
    // this.getSertifikasi();
  },

  methods : {
    ekspor() {
      this.$parent.exportDataPeserta(this.formFilter)
    },
    searchMethods(e) {
      this.$parent.syncSearch(e.target.value);
    },
    getPeriode() {
      PeriodeService.getPeriodeSelect()
      .then(response => {
        this.dataTahun = response.data.data
        var periode = this.dataTahun.find(el => el.status === '1' );                                    
        this.periode = periode;
        this.formFilter.periode = periode.value        
        this.loadingMultiSelect.isLoadingPeriode = false;
        this.getSertifikasi();
      }).catch(error => {
        // comment console console.log(error)
        this.loadingMultiSelect.isLoadingPeriode = false;
      })
    },
    filterData() {
      this.$parent.filterData(this.formFilter);
    },
    resetFilter() {
      this.periode = '';
      this.sertifikasi = '';
      this.formFilter.periode = ''
      this.formFilter.id_sertifikasi = ''
      $("#filterStatusPembayaran").val("");
    },
    dateFormat(classes, date) {
      let yesterday = moment().subtract(1, "day");
      if (!classes.disabled) {
        classes.disabled = moment(date).isSame(yesterday, "day");
      }
      return classes;
    },
    changePeriode(e) {
      // comment console console.log(e.value);
      this.formFilter.periode = e.value
    },
    
    forceUpper (e, obj, prop) {
      const start = e.target.selectionStart
      e.target.value = e.target.value.toUpperCase()
      this.$set(obj, prop, e.target.value)
      e.target.setSelectionRange(start, start)
    },
    
    changeSertifikasi(value) {
      this.formFilter.id_sertifikasi = value.id_sertifikasi
    },

    changePageSizeDataPesertaSertifikasi(e) {
      this.$parent.changePageSizeDataPesertaSertifikasi(e);
    },
    getSertifikasi() {
      var vm = this
      MasterSertifikasiService.getSertifikasi(0,100000,'default')
        .then(response => {
          this.dataSertifikasi = response.data.content;
          // this.sertifikasi = this.dataSertifikasi[0];
          // this.formFilter.id_sertifikasi = this.sertifikasi.id_sertifikasi;
          this.loadingMultiSelect.isLoadingSertifikasi = false
          // this.$parent.filterData(this.formFilter);
        })
        .catch(error => {
          // comment console console.log(error);
        });
    },
  },     
}
</script>